

























import Loader from '@/components/Loader.vue';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component({
  components: {
    Loader,
  },
})
export default class Button extends Vue {
  @Prop({ default: 'default' }) readonly size!: string;
  @Prop({ default: 'default' }) readonly variant!: string;
  @Prop({ default: 'inline' }) readonly display!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ type: String, default: '' }) readonly color!: string;
  @Prop(String) readonly type?: string;

  click() {
    if (this.loading) return;
    this.$emit('click');
  }
}
